import apiClient from '@/services/axios'

export async function post(event) {

  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/events/', event);
  event.eventId = response.eventId;
  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to post event.')
}
